import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import UUID from 'vue-uuid'
import vuetify from './plugins/vuetify'
import Vuetify from 'vuetify'
import mixin from './mixins/index'

// eslint-disable-next-line no-unused-vars
import {components, AmplifyEventBus, AmplifyPlugin} from 'aws-amplify-vue'
// eslint-disable-next-line no-unused-vars
import Amplify, * as AmplifyModules from 'aws-amplify'
// eslint-disable-next-line no-unused-vars
import awsconfig from './utils/AwsUtil'

import sanitizeHTML from 'sanitize-html'
Vue.prototype.$sanitize = sanitizeHTML

import VScrollLock from 'v-scroll-lock'
Vue.use(UUID)
Vue.use(VScrollLock)
Vue.use(Vuetify)
Vue.use(AmplifyPlugin, AmplifyModules)
Vue.config.productionTip = false

Vue.mixin(mixin)

/**
 * Get current authenticated user
 *
 * @return {object} data
 */
function getUser() {
  return Vue.prototype.$Amplify.Auth.currentAuthenticatedUser()
    .then((data) => {
      if (data && data.signInUserSession) {
        store.commit('auth/setUser', data)
        return data
      }
    })
    .catch(() => {
      store.commit('auth/setUser', null)
      return null
    })
}

AmplifyEventBus.$on('authState', async (state) => {
  if (state === 'signedOut') {
    store.commit('auth/setUser', null)
    router.push({path: '/'})
  } else if (state === 'signedIn') {
    await getUser()
    const redirectPath = store.getters['auth/getRedirectUrl']
      ? store.getters['auth/getRedirectUrl']
      : '/dashboard'
    router.push({path: redirectPath})
    store.commit('auth/setRedirectUrl', '')
  }
  if (state === 'withdraw') {
    store.commit('auth/setUser', null)
    router.push({path: '/delete_account_completed'})
  }
})

/**
 * init
 *
 * @return {void}
 */
async function init() {
  await getUser()
  new Vue({
    router,
    store,
    vuetify,
    render: (h) => h(App),
  }).$mount('#app')
}

router.beforeResolve(async (to, from, next) => {
  const user = await getUser()
  if (!user) {
    if (to.matched.some((record) => record.meta.requiresAuth)) {
      store.commit('auth/setRedirectUrl', to.path)
      return next({
        path: '/signIn',
      })
    }
  }
  return next()
})

init()
